import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { EnggDrawIP, SalesOrder, SaveStatusObj, SOModule, SaveEventType, ActualDateChange, ActualDateToken, PlannedDateToken, ValidationItem, ValidationSummary, SSOStatus, GenFileUploads, SubSalesOrder, SLDPropagationResult, SLDPropagationLog, SchemePropagationResult, SchemePropagationLog, FileElement } from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { FileUploadDialog } from '../../../dialogs/file-upload-dialog/file-upload-dialog';

@Component({
  selector: 'engg-draw',
  templateUrl: './engg-draw.component.html',
  styleUrls: ['./engg-draw.component.css']
})
export class EnggDrawComponent implements OnInit, OnChanges {

  @Input() enggDrawObj: EnggDrawIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter:SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();
  disableForm: boolean = true;
  public _SSOStatus = SSOStatus;

  modifyPlanDate:boolean = false;
  modifyReqDate:boolean = false;
  inputDisableMessage:string = 'NA';
  
  Hvr:any = {};

  // Multi-select "Apply to Sub Orders" state for Initial SLD Submission Actual date propagation.
  public eligibleSubOrdersForSLD: Array<SubSalesOrder> = [];
  public selectedPropagationSubOrderIds: Array<string> = [];

  // Multi-select "Apply to Sub Orders" state for Initial Schematic Drawing & BOM Submission Actual date propagation.
  public eligibleSubOrdersForScheme: Array<SubSalesOrder> = [];
  public selectedPropagationSchemeSubOrderIds: Array<string> = [];

  constructor(public _dataService: DataService,public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.ngOnChanges();
  }
  ngOnChanges() {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    // else if(!this.enggDrawObj.isProjectLive){
    //   this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    // }
    else if(!this.enggDrawObj.isInputEnabled){
      this.inputDisableMessage = "This form is not yet enabled.";
    }
    else if(!this._dataService.hasEnggDrawingEditAccess(this.enggDrawObj)){
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else{
      this.disableForm = false;
    }
    this.enggDrawObj.sldGtpUploads.disableUpload = this.disableForm;
    this.enggDrawObj.sldGtpUploads.headerStr = 'SLD Submission Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.revSldGtpUploads.disableUpload = this.disableForm;
    this.enggDrawObj.revSldGtpUploads.headerStr = 'Revised SLD/Scheme/GTP Calculation Uploads'  + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.schemeUploads.disableUpload = this.disableForm;
    this.enggDrawObj.schemeUploads.headerStr = 'Schematic Drawing & BOM Submission Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.gafMgaUploads.disableUpload = this.disableForm;
    this.enggDrawObj.gafMgaUploads.headerStr = 'GA Foundation/Cross section/MGA Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.enggDrawObj.revGafMgaUploads.disableUpload = this.disableForm;
    this.enggDrawObj.revGafMgaUploads.headerStr = 'Revised GA Foundation/Cross section/MGA Uploads' + " - " + this.enggDrawObj.parentSORef.marketingIP.salesOrderNo + "- Sub -" +this.enggDrawObj.parentSubSORef.subOrderNoId;
    this.refreshSLDPropagationEligibility();
    this.refreshSchemePropagationEligibility();
  }
  private refreshSLDPropagationEligibility() {
    if (!this.enggDrawObj) {
      this.eligibleSubOrdersForSLD = [];
      this.selectedPropagationSubOrderIds = [];
      return;
    }
    this.eligibleSubOrdersForSLD = this.enggDrawObj.getEligibleSiblingSubOrdersForSLDPropagation();
    let _validIds: { [k: string]: boolean } = {};
    for (let i = 0; i < this.eligibleSubOrdersForSLD.length; i++) {
      _validIds[this.eligibleSubOrdersForSLD[i].subOrderNoId] = true;
    }
    this.selectedPropagationSubOrderIds = (this.selectedPropagationSubOrderIds || []).filter(id => _validIds[id]);
  }
  private refreshSchemePropagationEligibility() {
    if (!this.enggDrawObj) {
      this.eligibleSubOrdersForScheme = [];
      this.selectedPropagationSchemeSubOrderIds = [];
      return;
    }
    this.eligibleSubOrdersForScheme = this.enggDrawObj.getEligibleSiblingSubOrdersForSchemePropagation();
    let _validIds: { [k: string]: boolean } = {};
    for (let i = 0; i < this.eligibleSubOrdersForScheme.length; i++) {
      _validIds[this.eligibleSubOrdersForScheme[i].subOrderNoId] = true;
    }
    this.selectedPropagationSchemeSubOrderIds = (this.selectedPropagationSchemeSubOrderIds || []).filter(id => _validIds[id]);
  }
  saveSso(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started){
    // Propagate SLD date to selected sub-orders (if any selected and date is set)
    if (this.enggDrawObj && (this.selectedPropagationSubOrderIds || []).length > 0) {
      let _uploadDate: Date = this.enggDrawObj.initialSLDSubmissionDateActual;
      if (_uploadDate) {
        let _result: SLDPropagationResult = this.enggDrawObj.applySLDDatePropagation(_uploadDate, this.selectedPropagationSubOrderIds, this._dataService.userId);
        if (_result && _result.updated && _result.updated.length > 0) {
          let _so: SalesOrder = this.enggDrawObj.parentSORef;
          if (_so) {
            if (!_so.sldPropagationLogs) _so.sldPropagationLogs = [];
            _so.sldPropagationLogs.push(new SLDPropagationLog(
              _result.sourceSubOrderId,
              _result.updated.slice(),
              _uploadDate,
              this._dataService.userId,
              _result.timestamp
            ));
          }
        }
        this.selectedPropagationSubOrderIds = [];
        this.refreshSLDPropagationEligibility();
      }
    }

    // Propagate Scheme date to selected sub-orders (if any selected and date is set)
    if (this.enggDrawObj && (this.selectedPropagationSchemeSubOrderIds || []).length > 0) {
      let _uploadDate: Date = this.enggDrawObj.initialSchematicDBOMSubmissionDateActual;
      if (_uploadDate) {
        let _result: SchemePropagationResult = this.enggDrawObj.applySchemeDatePropagation(_uploadDate, this.selectedPropagationSchemeSubOrderIds, this._dataService.userId);
        if (_result && _result.updated && _result.updated.length > 0) {
          let _so: SalesOrder = this.enggDrawObj.parentSORef;
          if (_so) {
            if (!_so.schemePropagationLogs) _so.schemePropagationLogs = [];
            _so.schemePropagationLogs.push(new SchemePropagationLog(
              _result.sourceSubOrderId,
              _result.updated.slice(),
              _uploadDate,
              this._dataService.userId,
              _result.timestamp
            ));
          }
        }
        this.selectedPropagationSchemeSubOrderIds = [];
        this.refreshSchemePropagationEligibility();
      }
    }
    
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  saveSsoo(_submitToNextSection:boolean,ssoSubmitTo:SSOStatus = SSOStatus.PM_Tech_EnggDraw | SSOStatus.SCM){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data),
          null,
          ssoSubmitTo
        ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.enggDrawObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.enggDrawObj[_actTokenKeyName].actualDate;
    this.enggDrawObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.enggDrawObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;

        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }

        this.enggDrawObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.enggDrawObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.enggDrawObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.enggDrawObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.enggDrawObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.enggDrawObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }
  showSsoPMTechValidation() {
    let _validList: Array<ValidationItem> = [];
    _validList.push(new ValidationItem("Technical CT details from Engg to PM Actual", (this.enggDrawObj.ctFinalizationGivenByEnggToPMActualDate ? true : false), " required for PM Tech & SCM."));

    if (this.enggDrawObj.isSplMatPapplicable) {
      _validList.push(new ValidationItem("Special price Mat Price Finalization Actual Date is Required ", (this.enggDrawObj.splMatActualDate ? true : false), " required for PM Tech."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });

  }

  showSsoEnggProcValidation(){
    let _validList:Array<ValidationItem> = [
      new ValidationItem("SLD & GA Approval Actual", (this.enggDrawObj.actualSLDGAApprovalDate ? true : false) ," required to move to Engg procurement." )    
    ] ;

    let vSummaryObj:ValidationSummary = new ValidationSummary("Validation Summary.",_validList);
    
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  datasheetSaveLockValidation() {
    let _validList: Array<ValidationItem> = [];
    if(!this.enggDrawObj.parentSORef.marketingIP.electricalEnggHandoverDetails.handoverStatus && !this.enggDrawObj.parentSORef.marketingIP.mechanicalEnggHandoverDetails.handoverStatus && this.enggDrawObj.parentSORef.hasDatasheetInSO){
      _validList.push(new ValidationItem("Electrical Engineering Handover Approval", (this.enggDrawObj.parentSORef.marketingIP.electricalEnggHandoverDetails.handoverStatus ? true : false), "for Datasheet is required."));
      _validList.push(new ValidationItem("Mechanical Engineering Handover Approval", (this.enggDrawObj.parentSORef.marketingIP.mechanicalEnggHandoverDetails.handoverStatus ? true : false), "for Datasheet is required."));
    }
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    // console.log(_validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }

  SLDGTPUploadsFileManagerClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
    // Open the file dialog locally (mirrors sub-salesorder.showGenFileUploadManager) so we can react on close
    // to trigger Initial SLD Submission Actual date propagation to selected sub-orders.
    let _uploads: GenFileUploads = this.enggDrawObj.sldGtpUploads;
    let _wasTokenBlank: boolean = (this.enggDrawObj.initialSLDSubmissionActualDateToken.actualDate == null);
    let _snapshotCount: number = _uploads.FileArray ? _uploads.FileArray.length : 0;
    let _selectedIds: Array<string> = (this.selectedPropagationSubOrderIds || []).slice();

    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: '80%',
      data: { message: "message", header: _uploads.headerStr, files: (_uploads ? _uploads.FileArray : []), readAccess: _uploads.disableUpload }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.handleSLDUploadDialogClosed(_wasTokenBlank, _snapshotCount, _selectedIds);
    });
  }
  private handleSLDUploadDialogClosed(_wasTokenBlank: boolean, _snapshotCount: number, _selectedIds: Array<string>) {
    if (!this.enggDrawObj) return;
    let _uploads: GenFileUploads = this.enggDrawObj.sldGtpUploads;
    let _currentCount: number = _uploads && _uploads.FileArray ? _uploads.FileArray.length : 0;
    // Validation 1 & 5: at least one file must have been uploaded during this session.
    if (_currentCount <= _snapshotCount) return;
    // Never overwrite existing dates on the current sub-order.
    if (!_wasTokenBlank) return;
    // Trigger the auto-date getter (matches existing behavior) to lock in a date derived from the newest file.
    let _uploadDate: Date = this.enggDrawObj.initialSLDSubmissionDateActual;
    if (!_uploadDate) return;

    if ((_selectedIds || []).length == 0) {
      // Only the current sub-order was updated by the auto-getter. Persist and stop.
      this.saveSso(false);
      return;
    }

    let _result: SLDPropagationResult = this.enggDrawObj.applySLDDatePropagation(_uploadDate, _selectedIds, this._dataService.userId);
    if (_result && _result.updated && _result.updated.length > 0) {
      let _so: SalesOrder = this.enggDrawObj.parentSORef;
      if (_so) {
        if (!_so.sldPropagationLogs) _so.sldPropagationLogs = [];
        _so.sldPropagationLogs.push(new SLDPropagationLog(
          _result.sourceSubOrderId,
          _result.updated.slice(),
          _uploadDate,
          this._dataService.userId,
          _result.timestamp
        ));
      }
    }
    this.selectedPropagationSubOrderIds = [];
    this.refreshSLDPropagationEligibility();
    this.saveSso(false);
  }
  private handleSchemeUploadDialogClosed(_wasTokenBlank: boolean, _snapshotCount: number, _selectedIds: Array<string>) {
    if (!this.enggDrawObj) return;
    let _uploads: GenFileUploads = this.enggDrawObj.schemeUploads;
    let _currentCount: number = _uploads && _uploads.FileArray ? _uploads.FileArray.length : 0;
    // Validation 1 & 5: at least one file must have been uploaded during this session.
    if (_currentCount <= _snapshotCount) return;
    // Never overwrite existing dates on the current sub-order.
    if (!_wasTokenBlank) return;
    // Trigger the auto-date getter (matches existing behavior) to lock in a date derived from the newest file.
    let _uploadDate: Date = this.enggDrawObj.initialSchematicDBOMSubmissionDateActual;
    if (!_uploadDate) return;

    if ((_selectedIds || []).length == 0) {
      // Only the current sub-order was updated by the auto-getter. Persist and stop.
      this.saveSso(false);
      return;
    }

    let _result: SchemePropagationResult = this.enggDrawObj.applySchemeDatePropagation(_uploadDate, _selectedIds, this._dataService.userId);
    if (_result && _result.updated && _result.updated.length > 0) {
      let _so: SalesOrder = this.enggDrawObj.parentSORef;
      if (_so) {
        if (!_so.schemePropagationLogs) _so.schemePropagationLogs = [];
        _so.schemePropagationLogs.push(new SchemePropagationLog(
          _result.sourceSubOrderId,
          _result.updated.slice(),
          _uploadDate,
          this._dataService.userId,
          _result.timestamp
        ));
      }
    }
    this.selectedPropagationSchemeSubOrderIds = [];
    this.refreshSchemePropagationEligibility();
    this.saveSso(false);
  }
  RevSLDGTPUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.revSldGtpUploads);
  }
  SchemeUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    // Open the file dialog locally (mirrors SLDGTPUploadsFileManagerClick) so we can react on close
    // to trigger Initial Schematic Drawing & BOM Submission Actual date propagation to selected sub-orders.
    let _uploads: GenFileUploads = this.enggDrawObj.schemeUploads;
    let _wasTokenBlank: boolean = (this.enggDrawObj.initialSchematicDBOMSubmissionActualDateToken.actualDate == null);
    let _snapshotCount: number = _uploads.FileArray ? _uploads.FileArray.length : 0;
    let _selectedIds: Array<string> = (this.selectedPropagationSchemeSubOrderIds || []).slice();

    let dialogRef = this.dialog.open(FileUploadDialog, {
      width: '80%',
      data: { message: "message", header: _uploads.headerStr, files: (_uploads ? _uploads.FileArray : []), readAccess: _uploads.disableUpload }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.handleSchemeUploadDialogClosed(_wasTokenBlank, _snapshotCount, _selectedIds);
    });
  }
  GAFMGAUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.gafMgaUploads);
  }
  RevGAFMGAUploadsFileManagerClick(_evnt){
    _evnt.stopPropagation();//stop ref
    this.showFileManager.emit(this.enggDrawObj.revGafMgaUploads);
  }

  // Validation: Check if current sub-order's SLD date was propagated from another sub-order
  isCurrentSubOrderSLDPropagationTarget(): boolean {
    if (!this.enggDrawObj || !this.enggDrawObj.parentSORef) return false;
    let _currentId = this.enggDrawObj.parentSubSORef ? this.enggDrawObj.parentSubSORef.subOrderNoId : null;
    let _so = this.enggDrawObj.parentSORef;
    if (!_so.sldPropagationLogs || _so.sldPropagationLogs.length == 0) return false;
    for (let i = 0; i < _so.sldPropagationLogs.length; i++) {
      if (Array.isArray(_so.sldPropagationLogs[i].targetSubOrderIds) &&
          _so.sldPropagationLogs[i].targetSubOrderIds.indexOf(_currentId) >= 0) {
        return true;
      }
    }
    return false;
  }

  // Validation: Check if current sub-order's Scheme date was propagated from another sub-order
  isCurrentSubOrderSchemePropagationTarget(): boolean {
    if (!this.enggDrawObj || !this.enggDrawObj.parentSORef) return false;
    let _currentId = this.enggDrawObj.parentSubSORef ? this.enggDrawObj.parentSubSORef.subOrderNoId : null;
    let _so = this.enggDrawObj.parentSORef;
    if (!_so.schemePropagationLogs || _so.schemePropagationLogs.length == 0) return false;
    for (let i = 0; i < _so.schemePropagationLogs.length; i++) {
      if (Array.isArray(_so.schemePropagationLogs[i].targetSubOrderIds) &&
          _so.schemePropagationLogs[i].targetSubOrderIds.indexOf(_currentId) >= 0) {
        return true;
      }
    }
    return false;
  }
}
